import Icon from '../components/Icon.vue'

Icon.register({
  peace: {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM432 256c0-90.5-65.8-165.8-152-181v165.7l129.4 103.5c14.4-26.2 22.6-56.2 22.6-88.2zM216 437v-114.5l-89.3 71.4c24.8 21.8 55.4 37 89.3 43zM280 322.6v114.4c33.9-6 64.5-21.2 89.3-43zM216 75c-86.2 15.2-152 90.5-152 181 0 31.9 8.2 62 22.6 88.2l129.4-103.5v-165.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/peace.js
// module id = 1617
// module chunks = 0